import ResumeComanda from './../MeseroPage/ResumeComandaComponent';

const CocinaBebidasComandaCard = (props) => <ResumeComanda {...props} />;

export default CocinaBebidasComandaCard;
